import { supabase } from './supabaseClient';

class SectionStorage {
  _toApp(row) {
    return {
      id: row.id,
      name: row.name,
      isDefault: row.is_default,
      createdAt: row.created_at
    };
  }

  async getAllSections() {
    const { data, error } = await supabase
      .from('sections')
      .select('*')
      .order('created_at', { ascending: true });

    if (error) throw error;
    return (data || []).map(row => this._toApp(row));
  }

  async createSection(sectionData) {
    const { data, error } = await supabase
      .from('sections')
      .insert({
        id: crypto.randomUUID(),
        name: sectionData.name,
        is_default: false
      })
      .select()
      .single();

    if (error) throw error;
    return this._toApp(data);
  }

  async updateSection(id, sectionData) {
    const { data, error } = await supabase
      .from('sections')
      .update({ name: sectionData.name })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return this._toApp(data);
  }

  async deleteSection(id) {
    // Check if default
    const { data: section } = await supabase
      .from('sections')
      .select('is_default')
      .eq('id', id)
      .single();

    if (section?.is_default) {
      throw new Error('Cannot delete default section');
    }

    const { error } = await supabase
      .from('sections')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
}

export const sectionStorage = new SectionStorage();
